import React from "react";
import { Link } from "react-router-dom";
import AltrustImage from "../../../src/assets/images/altruist.png";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import PersonIcon from "@mui/icons-material/Person";
import { Tooltip } from "@mui/material";
import { useLocation } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";

function Navbar() {
  const location = useLocation();
  const patname = location.pathname;

  return (
    <>
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Job Application</title>
      </head>

      <header class="header_1 position_sticky overla  fixed-top bg-transparen">
        <div class="container-fluid">
          <nav
            class="navbar navbar-expand-lg navbar-light justify-content-between bg-ligh text-white"
            // style={{ marginLeft: "-12px", marginRight: "-11px" }}
          >
            <div className="d-flex align-items-center text-dark">
              <a class="navbar-brand" href="#">
                <img src={AltrustImage} class="img-fluid d-block w-100" />
              </a>
              <div className="d-flex align-items-center">
                {/* <Tooltip title="BranchCode"> */}
                <div class="nav-item d-flex align-items-center m-2">
                  {/* <PersonIcon className="me-1" />{" "} */}
                  {/* <span>{localStorage.getItem("username")}</span> */}
                </div>
                {/* </Tooltip> */}
                {/* <Tooltip title="BranchState"> */}
                <div class="nav-item d-flex align-items-center m-2">
                  {/* <LocationCityIcon className="me-1" />{" "} */}
                  {/* <span>{localStorage.getItem("state")}</span> */}
                </div>
                {/* </Tooltip> */}
              </div>
            </div>
            <button
              class="navbar-toggler bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>

            <div
              class="collapse navbar-collapse flex-grow-0"
              id="navbarSupportedContent"
            >
              <div class="nav-item d-flex align-items-center m-2">
                  <PersonIcon className="me-1" />{" "}
                  <span>{localStorage.getItem("username")}</span>
                </div>
                
              <ul class="navbar-nav me-auto mb- mb-lg-0">
                <>

                <li
                    class="nav-item"
                    style={{
                      textDecoration: patname == "/" ? "underline" : "",
                    }}
                  >
                    <Link
                      // class={patname == "/" ? "nav-link active" : "nav-link"}
                      aria-current="page"
                      to="/"
                    >
                       <PersonIcon className="me-1" />
                      {/* <span>Home</span> */}
                    </Link>
                  </li>
                  {/* <li
                    class="nav-item"
                    style={{
                      textDecoration: patname == "/" ? "underline" : "",
                    }}
                  >
                    <Link
                      class={patname == "/" ? "nav-link active" : "nav-link"}
                      aria-current="page"
                      to="/"
                    >
                      <HomeIcon sx={{ color: "black" }} />
                      <span>Home</span>
                    </Link>
                  </li>

                  <li
                    class="nav-item"
                    style={{
                      textDecoration: patname == "/status" ? "underline" : "",
                    }}
                  >
                    <Link
                      class={
                        patname == "/status" ? "nav-link active" : "nav-link"
                      }
                      to="/status"
                    >
                      <QueryStatsIcon sx={{ color: "black" }} />
                      <span>Status</span>
                    </Link>
                  </li>

                  <li
                    class="nav-item"
                    style={{
                      textDecoration:
                        patname == "/transaction" ? "underline" : "",
                    }}
                  >
                    <Link
                      class={
                        patname == "/transaction"
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/transaction"
                    >
                      <FormatListNumberedIcon sx={{ color: "black" }} />
                      <span>Transaction History</span>
                    </Link>
                  </li> */}
                </>
              </ul>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
}

export default Navbar;
